export default __webpack_public_path__ + "static/media/fitness2.32bd6aff.PNG";